import type { PageFooterSectionName } from './types/PageFooterData';

export const pageFooterOrderedSectionsMetadata: {
  sectionName: PageFooterSectionName;
  desktopOnly?: true;
  abValue: 'OLD' | 'NEW';
}[] = [
  // TODO delete once new header is made default
  { sectionName: 'findAJob', desktopOnly: true, abValue: 'OLD' },
  { sectionName: 'takeAction', desktopOnly: true, abValue: 'OLD' },
  { sectionName: 'postOnIdealist', desktopOnly: true, abValue: 'OLD' },
  { sectionName: 'aboutUs', abValue: 'OLD' },
  { sectionName: 'learnMore', abValue: 'OLD' },

  { sectionName: 'getInvolved', desktopOnly: true, abValue: 'NEW' },
  { sectionName: 'findAJob', desktopOnly: true, abValue: 'NEW' },
  { sectionName: 'postOnIdealist', desktopOnly: true, abValue: 'NEW' },
  { sectionName: 'aboutUsNew', abValue: 'NEW' },
  { sectionName: 'contactUs', abValue: 'NEW' },
];
